// Utils
import { prop } from '../../../common/utils/immutableHelper';
import { getSuggestionsMap } from './suggestionUtils';
import { getElement } from '../../../common/elements/utils/elementTraversalUtils';

// Selector
import { getElements } from '../selectors/elementsSelector';

// Actions
import { elementSetTempData } from '../../../common/elements/elementActions';

const handleSuggestionChange =
    (willSuggest) =>
    ({ id, feature }) =>
    (dispatch, getState) => {
        const state = getState();
        const elements = getElements(state);
        const element = getElement(elements, id);

        if (!element) return;

        let currentSuggestionState = getSuggestionsMap(element);
        currentSuggestionState = currentSuggestionState ? currentSuggestionState.toJS() : {};
        const alreadySuggestedFeature = !!prop(feature, currentSuggestionState);

        if (willSuggest === alreadySuggestedFeature) return;

        return dispatch(
            elementSetTempData({
                id,
                data: {
                    suggestions: {
                        ...currentSuggestionState,
                        [feature]: willSuggest,
                    },
                },
            }),
        );
    };

export const elementSuggestFeature = handleSuggestionChange(true);
export const elementUnsuggestFeature = handleSuggestionChange(false);
